import { createRoot } from 'react-dom/client'
import App from './components/App'
import { StoreProvider } from './store'
import type { WidgetConfig } from './types'

for (const container of document.querySelectorAll<HTMLElement>(
  '[data-location-overview-config]'
)) {
  const configJSON = container.dataset.locationOverviewConfig
  if (!configJSON) {
    console.warn('Missing data-location-overview-config attribute')
    continue
  }
  const config = JSON.parse(configJSON) as WidgetConfig

  const reactRoot = createRoot(container)
  reactRoot.render(
    <StoreProvider config={config}>
      <App />
    </StoreProvider>
  )
}
